/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-17 12:36:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-22 11:14:01
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ArticleList/index.tsx
 */
import React from 'react';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import _ArticleList from 'src/components/Modules/ArticleList';
import ContentGroupHOC from '../HOC';
import { errKeys } from 'src/constrains/DraggableModules/tools';
import { EnumModuleType } from 'src/types/common/module';

const ArticleList = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    specificError,
    droppableId,
    draggableId,
  } = props || {};
  const { options } = React.useContext(ContentModuleGroupPreloadingContext);
  const _errKeys = errKeys[EnumModuleType.ArticleList];

  return (
    <_ArticleList
      contentPageList={options}
      configFieldsList={dynamicData}
      specificError={specificError}
      draggableId={draggableId}
      staticData={staticData}
      droppableId={droppableId}
      onItemDelete={handleOnItemDelete}
      onItemAdd={handleItemOnAdd}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      errKeys={_errKeys}
    />
  );
};
export default ContentGroupHOC(ArticleList);
